import React, { Component } from 'react';

import { Autocomplete, TextField } from '@mui/material';

class TextBox extends Component {
  renderTextField = params => (
    <TextField
      {...params}
      InputProps={{
        ...params.InputProps,
        type: 'search',
      }}
    />
  );

  render() {
    const { text, tags, onTextChange, onTagsChange, renderTags } = this.props;
    return (
      <Autocomplete
        fullWidth
        freeSolo
        multiple
        limitTags={2}
        id="free-solo-2-demo"
        disableClearable
        open={false}
        renderInput={this.renderTextField}
        options={tags.map(option => option.title)}
        renderTags={renderTags}
        value={tags}
        onChange={onTagsChange}
        inputValue={text}
        onInputChange={onTextChange}
      />
    );
  }
}

export default TextBox;
